import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getContactPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/kontakt",
		[Locale.en]: "/contact",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
